import { render, staticRenderFns } from "./ManageUsers.vue?vue&type=template&id=2044da6e&scoped=true&"
import script from "./ManageUsers.vue?vue&type=script&lang=js&"
export * from "./ManageUsers.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=2044da6e&prod&scoped=true&lang=css&"
import style1 from "./ManageUsers.vue?vue&type=style&index=1&id=2044da6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2044da6e",
  null
  
)

export default component.exports